import { render, staticRenderFns } from "./TeishutsuInputForm.vue?vue&type=template&id=5bf25d5c&scoped=true&"
import script from "./TeishutsuInputForm.vue?vue&type=script&lang=ts&"
export * from "./TeishutsuInputForm.vue?vue&type=script&lang=ts&"
import style0 from "./TeishutsuInputForm.vue?vue&type=style&index=0&id=5bf25d5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf25d5c",
  null
  
)

export default component.exports